export class CarrierImportValidationError {

  public fieldName: string;
  public fieldValue: string
  public message: string;
  public type: 'MISSING'|'CMAWEB_DUPLICATE'|'FILE_DUPLICATE'|'INEXISTANT'|'INVALID';

  static fromDto(data: any): CarrierImportValidationError {
    if (!data) {
      return null;
    }

    const validationError = new CarrierImportValidationError();

    validationError.fieldName  = data.field_name;
    validationError.fieldValue = data.field_value;
    validationError.message    = data.message;

    return validationError;
  }

  static toDtos(data: CarrierImportValidationError[]) {
    return data.map(d => ({
      field_name: d.fieldName,
      field_value: d.fieldValue,
      message: d.message
    }));
  }
}
